import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyStayUpgradeBenefitsModal from './LandingPageLoyaltyStayUpgradeBenefitsModal'

const image: App.Image = {
  id: 'wfzka1j5ru5d5e7hc9u',
  title: 'Free room upgrades',
}

interface Props {
  tier: App.LoyaltyTier
  benefitLabel: ReactElement
}

function LandingPageLoyaltyStayUpgrade(props: Props) {
  const { tier, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyStayUpgradeBenefitsModal
      image={image}
    />)
  }, [showModal])

  return <LandingPageLoyaltyBenefitTile
    heading={intl.formatMessage({
      id: 'T9aZU5yxSWE7xpKNLZzM',
      defaultMessage: 'Upgrade your stay',
      description: 'Heading for loyalty stay upgrade benefit tile component',
    })}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      {intl.formatMessage({
        id: 'sg5VQwpEgcR8OiZxdBjC',
        defaultMessage: 'Details',
        description: 'Link to open stay upgrade benefit details modal on the promotional landing page',
      })}
    </TextButton>}
  >
    <BodyText variant="medium">
      {intl.formatMessage({
        id: '-amVL4RnXViZkJCgPX7C',
        defaultMessage: 'Enjoy complimentary room and package upgrades at participating hotels\u2014subject to availability\u2014so you can travel in even more style.',
        description: 'Description of the complimentary room upgrade loyalty benefit',
      })}
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyStayUpgrade
